import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRateIndexAdditionalOptionsPanel extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelAdditionalOptions: Label;
    labelPricingBidHeader: Label;
    panelAdditionalOptions: Panel;
    sourceRateIndexControl: DataSource;
    switchGenerateMissingRatesForCurrentDate: Switch;
    switchRequestRateSwitchBatchProcess: Switch;
    textboxMilesPerGallon: Textbox;
    textboxNumberOfReports: Textbox;
    textboxSearchRange: Textbox;
    textboxTimeoutDuration: Textbox;
}
